<b>{{name}}</b>
<dl class="dl-horizontal m-b-0 m-t-15">
	{{#each fields}}
		{{#if value}}
			<dt>{{key}}</dt>
			<dd>{{value}}</dd>
		{{/if}}
	{{/each}}
</dl>
